export { DisplaySalary } from './DisplaySalary';
